import { render } from "./LandingScreen.vue?vue&type=template&id=054b3f47&scoped=true"
import script from "./LandingScreen.vue?vue&type=script&lang=js"
export * from "./LandingScreen.vue?vue&type=script&lang=js"

import "./LandingScreen.vue?vue&type=style&index=0&id=054b3f47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054b3f47"]])

export default __exports__